// src/components/themes/classified_soft/admin/BranchLogin.tsx
"use client";

import { Store, Lock, Mail, Eye, EyeOff, Loader2, ArrowRight } from "lucide-react";

interface BranchLoginProps {
  branchSlug: string;
  branchName?: string;
  email: string;
  setEmail: (val: string) => void;
  password: string;
  setPassword: (val: string) => void;
  showPassword: boolean;
  setShowPassword: (val: boolean) => void;
  loading: boolean;
  error: string | null;
  onSubmit: (e: React.FormEvent) => void;
}

export default function ClassifiedSoftBranchLogin({
  branchSlug,
  branchName,
  email,
  setEmail,
  password,
  setPassword,
  showPassword,
  setShowPassword,
  loading,
  error,
  onSubmit,
}: BranchLoginProps) {
  return (
    <div className="fixed inset-0 z-[99999] w-screen h-screen bg-[#f3f4f8] text-slate-800 flex items-center justify-center p-4 overflow-y-auto">
      <div className="w-full max-w-md bg-white/90 backdrop-blur-lg border border-white/60 rounded-[32px] p-8 shadow-[20px_20px_60px_#d1d5db,-20px_-20px_60px_#ffffff] space-y-6 my-auto">
        <div className="text-center space-y-2">
          <div className="w-14 h-14 rounded-2xl bg-indigo-50 border border-indigo-100 shadow-inner flex items-center justify-center mx-auto text-indigo-600">
            <Store className="w-7 h-7" />
          </div>
          <span className="inline-block px-3 py-1 rounded-full bg-indigo-50 text-indigo-600 text-[10px] font-black uppercase tracking-wider">
            Soft Outlet Dashboard
          </span>
          <h1 className="text-xl font-black text-slate-900 capitalize">
            {branchName || branchSlug.replace(/-/g, " ")}
          </h1>
          <p className="text-xs text-slate-500">
            ব্যবস্থাপনা প্যানেলে লগইন করুন
          </p>
        </div>

        {error && (
          <div className="p-3.5 rounded-2xl bg-rose-50 border border-rose-200 text-rose-600 text-xs font-bold">
            {error}
          </div>
        )}

        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="block text-xs font-bold text-slate-600 mb-1.5 ml-1">
              ইমেইল অ্যাড্রেস
            </label>
            <div className="relative flex items-center">
              <Mail className="w-4 h-4 absolute left-4 text-slate-400" />
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="manager@branch.com"
                className="w-full pl-11 pr-4 py-3 rounded-2xl text-xs font-bold bg-[#f8fafc] border border-slate-200 text-slate-800 outline-none focus:bg-white focus:ring-2 focus:ring-indigo-500/30 transition-all shadow-inner"
              />
            </div>
          </div>

          <div>
            <label className="block text-xs font-bold text-slate-600 mb-1.5 ml-1">
              পাসওয়ার্ড
            </label>
            <div className="relative flex items-center">
              <Lock className="w-4 h-4 absolute left-4 text-slate-400" />
              <input
                type={showPassword ? "text" : "password"}
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="w-full pl-11 pr-11 py-3 rounded-2xl text-xs font-bold bg-[#f8fafc] border border-slate-200 text-slate-800 outline-none focus:bg-white focus:ring-2 focus:ring-indigo-500/30 transition-all shadow-inner"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-4 text-slate-400 hover:text-slate-600"
              >
                {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
              </button>
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full py-3.5 rounded-2xl text-xs font-black text-white bg-indigo-600 hover:bg-indigo-700 shadow-[0_10px_20px_rgba(79,70,229,0.3)] transition-all flex items-center justify-center gap-2 cursor-pointer disabled:opacity-50"
          >
            {loading ? (
              <Loader2 className="w-4 h-4 animate-spin" />
            ) : (
              <>
                <span>লগইন করুন</span>
                <ArrowRight className="w-4 h-4" />
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );
}